import type { FC } from 'react'
import type { RewardsProgress as RewardsProgressType } from '@g4g/utils/src/types'
import useRewardsProgress from '../../../shopping-cart/hooks/useRewardsProgress'
import RewardProgressBar from './RewardProgressBar'
import { RewardType } from '@g4g/graphql/src/shop/__generated__/globalTypes'

const ProgressBars: FC<{ progress: RewardsProgressType }> = ({ progress }) => (
  <>
    <div className="flex w-full my-4 text-sm sm:sr-only text-white/50">Sale points</div>
    <div className="flex w-full px-8 sm:px-12">
      <RewardProgressBar type={RewardType.SalePoints} progress={progress.SalePoints} />
    </div>
    <div className="flex w-full my-4 text-sm sm:sr-only text-white/50">VIP experience</div>
    <div className="flex w-full px-8 sm:px-12">
      <RewardProgressBar type={RewardType.VipExp} progress={progress.VipExp} />
    </div>
  </>
)

const RewardsProgress: FC = () => {
  const { progress, loading } = useRewardsProgress()

  return (
    <>
      {!loading && (
        <div className="flex-grow mb-4 sm:mt-6">
          <div className="flex flex-col items-center sm:space-y-0 sm:h-full sm:flex-row">
            {progress && <ProgressBars progress={progress} />}
          </div>
        </div>
      )}
    </>
  )
}

export default RewardsProgress
